module.exports = __webpack_public_path__ + "img/welcome-logo-education.d1a584fd.svg";